import RDR from '@/statics/json-maps/dong-bang-song-hong.json';
import NMU from '@/statics/json-maps/trung-du-va-mien-nui-phia-bac.json';
import CCH from '@/statics/json-maps/duyen-hai-mien-trung.json';
import CHL from '@/statics/json-maps/tay-nguyen.json';
import SER from '@/statics/json-maps/dong-nam-bo.json';
import MD from '@/statics/json-maps/dong-bang-song-cuu-long.json';
import NER from '@/statics/json-maps/vung-kinh-te-trong-diem-phia-bac.json';
import CER from '@/statics/json-maps/vung-kinh-te-trong-diem-mien-trung.json';
import SKER from '@/statics/json-maps/vung-kinh-te-trong-diem-phia-nam.json';
import MDE from '@/statics/json-maps/vung-kinh-te-trong-diem-dbscl.json';
import CR from '@/statics/json-maps/vung-thu-do.json';
import CP28 from '@/statics/json-maps/dia-phuong-ven-bien.json';
import VN from '@/statics/json-maps/vietnam.json';
import SAE from '@/statics/json-maps/sau-vung-kinh-te.json';
import FAEK from '@/statics/json-maps/bon-vung-kinh-te-trong-diem.json';
import VNN from '@/statics/json-maps/vietnam2.json';

export const menuConfig = [
  // {
  //   id: 2,
  //   title: 'Dịch vụ',
  //   slug: '/dich-vu-va-giai-phap',
  //   hasChild: true,
  //   icon: 'menu_service',
  //   child: [
  //     {
  //       id: 2,
  //       title: 'Cung cấp dữ liệu kinh tế và thị trường',
  //       slug: '/dich-vu-va-giai-phap?tab=du-lieu-kinh-te-va-thi-truong',
  //     },
  //     {
  //       id: 2,
  //       title: 'Báo cáo phân tích kinh tế chuyên sâu ',
  //       slug: '/dich-vu-va-giai-phap?tab=phan-tich-chuyen-sau',
  //     },
  //     {
  //       id: 2,
  //       title: 'Khảo sát và phân tích theo nhu cầu thị trường',
  //       slug: '/dich-vu-va-giai-phap?tab=khao-sat',
  //     },
  //     {
  //       id: 2,
  //       title: 'Nghiên cứu và tư vấn chính sách',
  //       slug: '/dich-vu-va-giai-phap?tab=nghien-cuu-chinh-sach',
  //     },
  //     {
  //       id: 2,
  //       title: 'Đào tạo phân tích chính sách và kinh tế',
  //       slug: '/dich-vu-va-giai-phap?tab=tu-van-giai-phap',
  //     },
  //   ],
  // },
  {
    id: 1,
    title: 'Về chúng tôi',
    slug: '/gioi-thieu',
    icon: 'menu_about',
    hasChild: true,
    child: [
      {
        id: 7,
        title: 'Dịch vụ',
        slug: '/dich-vu-va-giai-phap',
        hasChild: true,
        child: [
          {
            id: 2,
            title: 'Cung cấp dữ liệu kinh tế và thị trường',
            slug: '/dich-vu-va-giai-phap?tab=du-lieu-kinh-te-va-thi-truong',
          },
          {
            id: 2,
            title: 'Báo cáo phân tích kinh tế chuyên sâu ',
            slug: '/dich-vu-va-giai-phap?tab=phan-tich-chuyen-sau',
          },
          {
            id: 2,
            title: 'Khảo sát và phân tích theo nhu cầu thị trường',
            slug: '/dich-vu-va-giai-phap?tab=khao-sat',
          },
          {
            id: 2,
            title: 'Nghiên cứu và tư vấn chính sách',
            slug: '/dich-vu-va-giai-phap?tab=nghien-cuu-chinh-sach',
          },
          {
            id: 2,
            title: 'Đào tạo phân tích chính sách và kinh tế',
            slug: '/dich-vu-va-giai-phap?tab=tu-van-giai-phap',
          },
        ],
      },
      { id: 1, title: 'Giới thiệu', slug: '/gioi-thieu' },
      { id: 2, title: 'Sứ mạng', slug: '/gioi-thieu' },
      { id: 3, title: 'Tầm nhìn', slug: '/gioi-thieu' },
      { id: 4, title: 'Giá trị cốt lõi', slug: '/gioi-thieu' },
      { id: 5, title: 'Tin tức', slug: '/tin-tuc' },
      // { id: 5, title: 'Tài liệu tích hợp API', slug: '/tai-lieu-api' },
      // { id: 6, title: 'Đội ngũ quản lý', slug: '/doi-ngu-quan-ly' },
    ],
  },
  {
    id: 3,
    title: 'Dữ liệu kinh tế',
    slug: '/du-lieu-kinh-te',
    hasChild: true,
    icon: 'menu_chart',
    child: [
      {
        id: 21,
        title: 'Chỉ báo kinh tế vĩ mô chính',
        slug: '/chi-so/du-lieu-kinh-te/cac-chi-so-chinh?name=Chỉ báo kinh tế vĩ mô chính',
      },
      {
        id: 22,
        title: 'Kinh tế vĩ mô ',
        slug: '/du-lieu-kinh-te?slug=kinh-te-vi-mo?name=Kinh tế vĩ mô',
        hasChild: true,
        child: [
          {
            id: 22,
            title: 'GDP - Tăng trưởng',
            slug: '/chi-so/du-lieu-kinh-te/gdp-tang-truong?name=GDP - Tăng trưởng',
          },
          {
            id: 22,
            title: 'Tài chính - Tiền tệ',
            slug: '/chi-so/du-lieu-kinh-te/tai-chinh-tien-te?name=Tài chính - Tiền tệ',
          },
          {
            id: 22,
            title: 'Tài khóa - Nợ công',
            slug: '/chi-so/du-lieu-kinh-te/tai-khoa-va-no-cong?name=Tài khóa - Nợ công',
          },
          {
            id: 22,
            title: 'Giá cả - Lạm phát',
            slug: '/chi-so/du-lieu-kinh-te/gia-ca-lam-phat?name=Giá cả - Lạm phát',
          },
          {
            id: 22,
            title: 'Lao động - Việc làm',
            slug: '/chi-so/du-lieu-kinh-te/lao-dong-viec-lam?name=Lao động - Việc làm',
          },
          {
            id: 22,
            title: 'Đầu tư - FDI',
            slug: '/chi-so/du-lieu-kinh-te/dau-tu-fdi?name=Đầu tư - FDI',
          },
          {
            id: 22,
            title: 'Xuất nhập khẩu',
            slug: '/chi-so/du-lieu-kinh-te/nhap-khau?name=Xuất nhập khẩu',
          },
          {
            id: 22,
            title: 'Doanh nghiệp ',
            slug: '/chi-so/du-lieu-kinh-te/doanh-nghiep?name=Doanh nghiệp',
          },
        ],
      },
      {
        id: 23,
        title: 'Cán cân thanh toán',
        slug: '/chi-so/du-lieu-kinh-te/can-can-thanh-toan',
      },
      {
        id: 24,
        title: 'Kinh tế tư nhân',
        slug: '/chi-so/du-lieu-kinh-te/kinh-te-tu-nhan?name=Kinh tế tư nhân',
      },
      {
        id: 25,
        title: 'Doanh nghiệp nhà nước',
        slug: '/chi-so/du-lieu-kinh-te/doanh-nghiep-nha-nuoc?name=Doanh nghiệp nhà nước',
      },
      {
        id: 26,
        title: 'Kinh tế số',
        slug: '/chi-so/du-lieu-kinh-te/kinh-te-so?name=Kinh tế số',
      },
      {
        id: 27,
        title: 'Kinh tế xanh - Tuần hoàn',
        slug: '/chi-so/du-lieu-kinh-te/kinh-te-xanh-tuan-hoan?name=Kinh tế xanh - Tuần hoàn',
      },
      {
        id: 28,
        title: 'Thống kê quốc tế',
        slug: '/chi-so/du-lieu-kinh-te/thong-ke-quoc-te?name=Thống kê quốc tế',
      },
      {
        id: 29,
        title: 'Thống kê xã hội',
        slug: '/chi-so/du-lieu-kinh-te/thong-ke-xa-hoi?name=Thống kê xã hội',
      },
      {
        id: 30,
        title: 'Thống kê tổng hợp khác',
        slug: '/chi-so/du-lieu-kinh-te/thong-ke-tong-hop-khac?name=Thống kê tổng hợp khác',
      },
    ],
  },
  {
    id: 4,
    title: 'Kinh tế ngành',
    slug: '/kinh-te-nganh',
    hasChild: true,
    icon: 'menu_signal',
    child: [
      {
        id: 4,
        title: 'Chỉ báo kinh tế ngành tổng hợp',
        slug: '/chi-so/kinh-te-nganh/chi-bao-kinh-te-nganh-tong-hop?name=Chỉ báo kinh tế ngành tổng hợp',
      },
      {
        id: 4,
        title: 'Nông nghiệp',
        slug: '/chi-so/kinh-te-nganh/nong-nghiep?name=Nông nghiệp',
      },
      {
        id: 4,
        title: 'Công nghiệp',
        slug: '/chi-so/kinh-te-nganh/cong-nghiep?name=Công nghiệp',
      },
      {
        id: 4,
        title: 'Xây dựng',
        slug: '/chi-so/kinh-te-nganh/xay-dung?name=Xây dựng',
      },
      {
        id: 4,
        title: 'Thương mại - Dịch vụ',
        slug: '/chi-so/kinh-te-nganh/thuong-mai-dich-vu?name=Thương mại - Dịch vụ',
      },
      {
        id: 4,
        title: 'Tài chính - Ngân hàng',
        slug: '/chi-so/kinh-te-nganh/tai-chinh-ngan-hang?name=Tài chính - Ngân hàng',
      },
      {
        id: 4,
        title: 'Bất động sản',
        slug: '/chi-so/kinh-te-nganh/bat-dong-san?name=Bất động sản',
      },
      {
        id: 4,
        title: 'Chứng khoán - M&A',
        slug: '/chi-so/kinh-te-nganh/chung-khoan-ma?name=Chứng khoán - M&A',
      },
      {
        id: 4,
        title: 'Bảo hiểm',
        slug: '/chi-so/kinh-te-nganh/bao-hiem?name=Bảo hiểm',
      },
      {
        id: 4,
        title: 'Báo cáo tài chính',
        slug: '/chi-so/kinh-te-nganh/bao-cao-tai-chinh?name=Báo cáo tài chính',
      },
      {
        id: 4,
        title: 'Vận tải - Viễn thông',
        slug: '/chi-so/kinh-te-nganh/van-tai-vien-thong?name=Vận tải - Viễn thông',
      },
    ],
  },
  {
    id: 5,
    title: 'Kinh tế địa phương',
    slug: '/kinh-te-dia-phuong',
    hasChild: true,
    icon: 'menu_marker',
    child: [
      {
        id: 5,
        title: 'Cập nhật kinh tế địa phương',
        slug: '/kinh-te-dia-phuong?slug=cap-nhat-kinh-te-dia-phuong',
      },
      {
        id: 5,
        title: 'Kinh tế địa phương tổng hợp',
        slug: '/chi-so/kinh-te-dia-phuong/kinh-te-dia-phuong-tong-hop?name=Kinh tế địa phương tổng hợp',
      },
      {
        id: 5,
        title: 'Kinh tế các tỉnh-thành',
        slug: '/chi-so/kinh-te-dia-phuong/kinh-te-tinh-thanh/local?name=Kinh tế các tỉnh-thành',
      },
      {
        id: 5,
        title: 'Kinh tế địa phương',
        slug: '/chi-so/kinh-te-dia-phuong/kinh-te-dia-phuong/local?name=Kinh tế địa phương',
      },
      {
        id: 5,
        title: 'Kinh tế vùng',
        slug: '/chi-so/kinh-te-dia-phuong/kinh-te-vung/local? ',
      },
    ],
  },
  {
    id: 6,
    title: 'Con số biết nói',
    slug: '/con-so-biet-noi',
    icon: 'menu_calendar',
  },
  {
    id: 7,
    title: 'Tài nguyên',
    slug: '/tai-nguyen',
    hasChild: true,
    icon: 'menu_doc',
    child: [
      { id: 7, title: 'Tài nguyên', slug: '/tai-nguyen' },
      {
        id: 7,
        title: 'Tài liệu tích hợp API',
        slug: '/tai-lieu-api',
      },
    ],
  },
];

export const chartDefined = [
  { id: 0, icon: 'column_chart', label: 'Biểu đồ cột dọc', value: 'column' },
  { id: 1, icon: 'bar_chart', label: 'Biểu đồ cột ngang', value: 'bar' },
  { id: 2, icon: 'line_chart', label: 'Biểu đồ dây', value: 'line' },
  {
    id: 3,
    icon: 'stack_value',
    label: 'Biểu đồ cơ cấu theo giá trị',
    value: 'stack-value',
  },
  {
    id: 4,
    icon: 'stacked_bar',
    label: 'Biểu đồ cơ cấu theo 100%',
    value: 'stack-percent',
  },
  { id: 6, icon: 'dual_axes', label: 'Biểu đồ hỗn hợp', value: 'column-line' },
  { id: 7, icon: 'area-graph', label: 'Biểu đồ vùng', value: 'area' },
  { id: 8, icon: 'pie-chart', label: 'Biểu đồ tròn', value: 'pie' },
  {
    id: 9,
    icon: 'column_chart',
    label: 'Biểu đồ cột dọc',
    value: 'group-column',
  },
  { id: 9, icon: 'maps', label: 'Bản đồ', value: 'maps' },
];

export const chartIcon: Record<string, string> = {
  column: 'column_chart',
  bar: 'bar_chart',
  line: 'line_chart',
  stack_value: 'stack_value',
  stack_percent: 'stacked_bar',
  column_line: 'dual_axes',
  area: 'area-graph',
  pie: 'pie-chart',
  group_column: 'column_chart',
};

export const typeChart = [
  { id: 0, icon: 'column_chart', label: 'Biểu đồ cột dọc', value: 'column' },
  { id: 1, icon: 'bar_chart', label: 'Biểu đồ cột ngang', value: 'bar' },
  { id: 2, icon: 'line_chart', label: 'Biểu đồ dây', value: 'line' },
  {
    id: 3,
    icon: 'stack_value',
    label: 'Biểu đồ cơ cấu giá trị',
    value: 'stack-value',
  },
  {
    id: 4,
    icon: 'stacked_bar',
    label: 'Biểu đồ cơ cấu 100%',
    value: 'stack-percent',
  },
  // { id: 6, icon: "radial_chart", label: 'Biểu đồ cột tròn', value: 'radial-bar' },
  { id: 7, icon: 'area-graph', label: 'Biểu đồ vùng', value: 'area' },
];

export const typeSearch = [
  { id: 0, icon: 'indicator', label: 'Tìm kiếm tất cả', value: 'all' },
  { id: 1, icon: 'pie-chart', label: 'Dữ liệu kinh tế', value: 'indicator' },
  {
    id: 2,
    icon: 'industry',
    label: 'Kinh tế ngành',
    value: 'industry_indicator',
  },
  { id: 3, icon: 'local', label: 'KT địa phương', value: 'local_indicator' },
  { id: 4, icon: 'article', label: 'Con số biết nói', value: 'articles' },
];
export const rangeYear = [
  { id: 1, type: 'default', label: '5Y', value: 5 },
  { id: 2, type: 'default', label: '10Y', value: 10 },
  { id: 3, type: 'default', label: '20Y', value: 20 },
  { id: 4, type: 'default', label: '30Y', value: 30 },
  { id: 5, type: 'full', label: 'MAX' },
];

export const rangeYearMobile = [
  { label: '5Y', key: '5' },
  { label: '10Y', key: '10' },
  { label: '20Y', key: '20' },
  { label: '30Y', key: '30' },
  { label: 'MAX', key: 'max' },
];
export const rangeMonthQuarter = [
  { id: 1, type: 'default', label: '1Y', value: 1 },
  { id: 2, type: 'default', label: '3Y', value: 3 },
  { id: 3, type: 'default', label: '5Y', value: 5 },
  { id: 4, type: 'default', label: '10Y', value: 10 },
  { id: 5, type: 'full', label: 'MAX' },
];
export const rangeDay = [
  { id: 1, type: 'default', label: '1M', value: 1 / 12 },
  { id: 2, type: 'default', label: '3M', value: 1 / 6 },
  { id: 3, type: 'default', label: '6M', value: 0.5 },
  { id: 4, type: 'default', label: '1Y', value: 1 },
  { id: 5, type: 'full', label: 'MAX' },
];

export const mapDataDefaultAllowArea = [
  //Đồng Bằng Sông Hồng
  {
    keyMapping: 'vn-318',
    value: Math.floor(Math.random() * 80),
    name: 'Hà Nội',
  },
  {
    keyMapping: 'vn-bn',
    value: Math.floor(Math.random() * 80),
    name: 'Bắc Ninh',
  },
  {
    keyMapping: 'vn-hm',
    value: Math.floor(Math.random() * 80),
    name: 'Hà Nam',
  },
  {
    keyMapping: 'vn-hd',
    value: Math.floor(Math.random() * 80),
    name: 'Hải Dương',
  },
  {
    keyMapping: 'vn-3623',
    value: Math.floor(Math.random() * 80),
    name: 'TP. Hải Phòng',
  },
  {
    keyMapping: 'vn-317',
    value: Math.floor(Math.random() * 80),
    name: 'Hưng Yên',
  },
  {
    keyMapping: 'vn-nd',
    value: Math.floor(Math.random() * 80),
    name: 'Nam Định',
  },
  {
    keyMapping: 'vn-tb',
    value: Math.floor(Math.random() * 80),
    name: 'Thái Bình',
  },
  {
    keyMapping: 'vn-vc',
    value: Math.floor(Math.random() * 80),
    name: 'Vĩnh Phúc',
  },
  {
    keyMapping: 'vn-nb',
    value: Math.floor(Math.random() * 80),
    name: 'Ninh Bình',
  },

  //Đông Bắc Bộ
  {
    keyMapping: 'vn-pt',
    value: Math.floor(Math.random() * 80),
    name: 'Phú Thọ',
  },
  {
    keyMapping: 'vn-hg',
    value: Math.floor(Math.random() * 80),
    name: 'Hà Giang',
  },
  {
    keyMapping: 'vn-tq',
    value: Math.floor(Math.random() * 80),
    name: 'Tuyên Quang',
  },
  {
    keyMapping: 'vn-cb',
    value: Math.floor(Math.random() * 80),
    name: 'Cao Bằng',
  },
  {
    keyMapping: 'vn-307',
    value: Math.floor(Math.random() * 80),
    name: 'Bắc Kạn',
  },
  {
    keyMapping: 'vn-ty',
    value: Math.floor(Math.random() * 80),
    name: 'Thái Nguyên',
  },
  {
    keyMapping: 'vn-ls',
    value: Math.floor(Math.random() * 80),
    name: 'Lạng Sơn',
  },
  {
    keyMapping: 'vn-bg',
    value: Math.floor(Math.random() * 80),
    name: 'Bắc Giang',
  },
  {
    keyMapping: 'vn-qn',
    value: Math.floor(Math.random() * 80),
    name: 'Quảng Ninh',
  },
  //Tây Bắc Bộ
  {
    keyMapping: 'vn-ho',
    value: Math.floor(Math.random() * 80),
    name: 'Hòa Bình',
  },
  {
    keyMapping: 'vn-311',
    value: Math.floor(Math.random() * 80),
    name: 'Sơn La',
  },
  {
    keyMapping: 'vn-db',
    value: Math.floor(Math.random() * 80),
    name: 'Điện Biên',
  },
  {
    keyMapping: 'vn-li',
    value: Math.floor(Math.random() * 80),
    name: 'Lai Châu',
  },
  {
    keyMapping: 'vn-lo',
    value: Math.floor(Math.random() * 80),
    name: 'Lào Cai',
  },
  {
    keyMapping: 'vn-yb',
    value: Math.floor(Math.random() * 80),
    name: 'Yên Bái',
  },

  //Bắc Trung Bộ
  {
    keyMapping: 'vn-th',
    value: Math.floor(Math.random() * 80),
    name: 'Thanh Hóa',
  },
  {
    keyMapping: 'vn-na',
    value: Math.floor(Math.random() * 80),
    name: 'Nghệ An',
  },
  {
    keyMapping: 'vn-328',
    value: Math.floor(Math.random() * 80),
    name: 'Hà Tĩnh',
  },
  {
    keyMapping: 'vn-qb',
    value: Math.floor(Math.random() * 80),
    name: 'Quảng Bình',
  },
  {
    keyMapping: 'vn-qt',
    value: Math.floor(Math.random() * 80),
    name: 'Quảng Trị',
  },
  {
    keyMapping: 'vn-tt',
    value: Math.floor(Math.random() * 80),
    name: 'TP. Huế',
  },
  //Nam Trung Bộ
  {
    keyMapping: 'vn-da',
    value: Math.floor(Math.random() * 80),
    name: 'TP. Đà Nẵng',
  },
  {
    keyMapping: 'vn-797',
    value: Math.floor(Math.random() * 80),
    name: 'Hoàng Sa, Việt Nam',
  },
  {
    keyMapping: 'vn-300',
    value: Math.floor(Math.random() * 80),
    name: 'Quảng Nam',
  },
  {
    keyMapping: 'vn-qg',
    value: Math.floor(Math.random() * 80),
    name: 'Quảng Ngãi',
  },
  {
    keyMapping: 'vn-bd',
    value: Math.floor(Math.random() * 80),
    name: 'Bình Định',
  },
  {
    keyMapping: 'vn-py',
    value: Math.floor(Math.random() * 80),
    name: 'Phú Yên',
  },
  {
    keyMapping: 'vn-kh',
    value: Math.floor(Math.random() * 80),
    name: 'Khánh Hòa',
  },
  {
    keyMapping: 'vn-796',
    value: Math.floor(Math.random() * 80),
    name: 'Trường Sa, Việt Nam',
  },
  {
    keyMapping: 'vn-nt',
    value: Math.floor(Math.random() * 80),
    name: 'Ninh Thuận',
  },
  {
    keyMapping: 'vn-bu',
    value: Math.floor(Math.random() * 80),
    name: 'Bình Thuận',
  },

  //Tây nguyên
  {
    keyMapping: 'vn-299',
    value: Math.floor(Math.random() * 80),
    name: 'Kon Tum',
  },
  {
    keyMapping: 'vn-724',
    value: Math.floor(Math.random() * 80),
    name: 'Gia Lai',
  },
  {
    keyMapping: 'vn-723',
    value: Math.floor(Math.random() * 80),
    name: 'Đắk Lắk',
  },
  {
    keyMapping: 'vn-6365',
    value: Math.floor(Math.random() * 80),
    name: 'Đắk Nông',
  },
  {
    keyMapping: 'vn-ld',
    value: Math.floor(Math.random() * 80),
    name: 'Lâm Đồng',
  },
  //Đông Nam Bộ
  {
    keyMapping: 'vn-hc',
    value: Math.floor(Math.random() * 80),
    name: 'Thành phố Hồ Chí Minh',
  },
  {
    keyMapping: 'vn-bv',
    value: Math.floor(Math.random() * 80),
    name: 'Bà Rịa - Vũng Tàu',
  },
  {
    keyMapping: 'vn-bi',
    value: Math.floor(Math.random() * 80),
    name: 'Bình Dương',
  },
  {
    keyMapping: 'vn-bp',
    value: Math.floor(Math.random() * 80),
    name: 'Bình Phước',
  },
  {
    keyMapping: 'vn-331',
    value: Math.floor(Math.random() * 80),
    name: 'Đồng Nai',
  },
  {
    keyMapping: 'vn-tn',
    value: Math.floor(Math.random() * 80),
    name: 'Tây Ninh',
  },
  //Đồng Bằng Sông Cửu Long
  {
    keyMapping: 'vn-ag',
    value: Math.floor(Math.random() * 80),
    name: 'An Giang',
  },
  {
    keyMapping: 'vn-bl',
    value: Math.floor(Math.random() * 80),
    name: 'Bạc Liêu',
  },
  {
    keyMapping: 'vn-br',
    value: Math.floor(Math.random() * 80),
    name: 'Bến Tre',
  },
  {
    keyMapping: 'vn-cm',
    value: Math.floor(Math.random() * 80),
    name: 'Cà Mau',
  },
  {
    keyMapping: 'vn-333',
    value: Math.floor(Math.random() * 80),
    name: 'TP. Cần Thơ',
  },
  {
    keyMapping: 'vn-dt',
    value: Math.floor(Math.random() * 80),
    name: 'Ðồng Tháp',
  },
  {
    keyMapping: 'vn-337',
    value: Math.floor(Math.random() * 80),
    name: 'Hậu Giang',
  },
  {
    keyMapping: 'vn-kg',
    value: Math.floor(Math.random() * 80),
    name: 'Kiên Giang',
  },
  {
    keyMapping: 'vn-la',
    value: Math.floor(Math.random() * 80),
    name: 'Long An',
  },
  {
    keyMapping: 'vn-st',
    value: Math.floor(Math.random() * 80),
    name: 'Sóc Trăng',
  },
  {
    keyMapping: 'vn-tg',
    value: Math.floor(Math.random() * 80),
    name: 'Tiền Giang',
  },
  {
    keyMapping: 'vn-tv',
    value: Math.floor(Math.random() * 80),
    name: 'Trà Vinh',
  },
  {
    keyMapping: 'vn-vl',
    value: Math.floor(Math.random() * 80),
    name: 'Vĩnh Long',
  },
  //Other
  {
    keyMapping: 'vn-ts',
    value: Math.floor(Math.random() * 80),
    name: 'Trường Sa',
  },
  {
    keyMapping: 'vn-hs',
    value: Math.floor(Math.random() * 80),
    name: 'Hoàng Sa',
  },
];

export const jsonMaps: Record<string, any> = {
  // Red River Delta (Đồng Bằng Sông Hồng)
  RDR: RDR,
  // Northern Midlands and Uplands (Trung Du và Miền Núi Phía Bắc)
  NMU: NMU,
  // Central Coastal Region (Duyên Hải Miền Trung)
  CCH: CCH,
  // Central Highlands (Tây Nguyên)
  CHL: CHL,
  // Southeast Region (Đông Nam Bộ)
  SER: SER,
  // Mekong Delta (Đồng Bằng Sông Cửu Long)
  MD: MD,
  // Northern Economic Region (Vùng Kinh Tế Trọng Điểm Phía Bắc)
  NER: NER,
  // Central Economic Region (Vùng Kinh Tế Trọng Điểm Miền Trung)
  CER: CER,
  // Southern Key Economic Region (Vùng Kinh Tế Trọng Điểm Phía Nam)
  SKER: SKER,
  // Mekong Delta Economic Region (Vùng Kinh Tế Trọng Điểm ĐBSCL)
  MDE: MDE,
  // Capital Region (Vùng Thủ Đô)
  CR: CR,
  // 28 Coastal Provinces (28 Địa Phương Ven Biển)
  CP28: CP28,
  // Vietnam
  VN: VN,
  // Vietnam
  SAE: SAE,
  // Vietnam
  FAEK: FAEK,
  // Vietnam 34 provinces
  VNN: VNN,
};

export const dataMapStatic = [
  {
    'hc-key': 'vn-dcd',
    value: 0,
    name: 'Côn Đảo',
    id: '0e584d22-4985-457c-1111-111111',
    keyMapping: 'vn-dcd',
  },
  {
    'hc-key': 'vn-pqi',
    value: 0,
    name: 'Phú Quốc',
    id: '0e584d22-4985-457c-222-222222',
    keyMapping: 'vn-pqi',
  },
  {
    'hc-key': 'vn-tsi',
    value: 0,
    name: 'QĐ. Trường sa',
    id: '0e584d22-4985-457c-3333-333333',
    keyMapping: 'vn-tsi',
  },
  {
    'hc-key': 'vn-hsi',
    value: 0,
    name: 'QĐ. Hoàng sa',
    id: '0e584d22-4985-457c-4444-44444444',
    keyMapping: 'vn-hsi',
  },
];

// const NewMapAreaKeys = {
//   tp_ho_chi_minh: 'vn_hcm',
//   ha_noi: 'vn_hn',
//   tp_hai_phong: 'vn_hp',
//   dong_nai: 'vn_dn',
//   bac_ninh: 'vn_bn',
//   phu_tho: 'vn_pt',
//   quang_ninh: 'vn_qnh',
//   thanh_hoa: 'vn_th',
//   lam_dong: 'vn_ld',
//   tay_ninh: 'vn_tnh',
//   can_tho: 'vn_ct',
//   da_nang: 'vn_dng',
//   kien_giang: 'vn_kg',
//   ninh_binh: 'vn_nb',
//   dong_thap: 'vn_dt',
//   ben_tre: 'vn_bt',
//   gia_lai: 'vn_gl',
//   hung_yen: 'vn_hy',
//   nghe_an: 'vn_na',
//   dak_lak: 'vn_dl',
//   khanh_hoa: 'vn_kh',
//   thai_nguyen: 'vn_tn',
//   quang_ngai: 'vn_qn',
//   ca_mau: 'vn_cm',
//   lao_cai: 'vn_lc',
//   quang_tri: 'vn_qt',
//   ha_tinh: 'vn_ht',
//   tuyen_quang: 'vn_tq',
//   tp_hue: 'vn_hue',
//   son_la: 'vn_sl',
//   lang_son: 'vn_ls',
//   dien_bien: 'vn_db',
//   lai_chau: 'vn_lcu',
//   cao_bang: 'vn_cb',
// };
